export default "__VITE_ASSET__BGzFokzG__"